<template>
  <div>
    <div class="vx-row tabs-container pt-6 pb-4 items-center">
      <div class="vx-col flex items-center w-1/3">
        <div style="font-size: 1.5rem; font-weight: 550" class="ml-2">
          {{ $t("customers.label.more_info") }}
        </div>
      </div>
      <div
        :class="[
          'vx-col flex items-center',
          taxExemption ? 'justify-end w-1/3' : 'justify-end tax',
        ]"
      >
        <small class="mr-3">{{ $t("customers.label.TaxExemption") }}</small>
        <vs-switch
          color="success"
          class="mr-3"
          icon-pack="feather"
          vs-icon-on="icon-check-circle"
          vs-icon-off="icon-slash"
          v-model="taxExemption"
          @input="updateTaxExemption"
        >
          <span slot="on">{{ $t("customers.label.YES") }}</span>
          <span slot="off">{{ $t("customers.label.NO") }}</span>
        </vs-switch>
      </div>
      <div class="vx-col w-1/3" v-if="taxExemption">
        <vs-input
          :label="$t('customers.label.SelectTaxExemption')"
          v-model="selectedNumber"
          type="text"
          class="w-full font-semibold"
          @input="updateTaxExemption"
        />
      </div>
    </div>
    <vs-tabs alignment="fixed" v-model="activeTab" class="tab-action-btn-fill-conatiner">
      <vs-tab :label="$t('customers.label.identities')">
        <div class="tab-text mx-2">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="identifiers"
            description
            search
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <span class="vx-col order-1">
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="truncate"
                  @click="handleAddClientIdentities"
                  size="small"
                  >{{ $t("customers.label.add_client_identities") }}</vs-button
                >
              </span>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.unique_identification") }}</vs-th>
              <vs-th>{{ $t("customers.label.description") }}</vs-th>
              <vs-th>{{ $t("customers.label.type") }}</vs-th>
              <vs-th>{{ $t("customers.label.identity_documents") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("customers.label.action") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(identifier, index) in data">
                <vs-td :data="identifier.documentKey">{{ identifier.documentKey }}</vs-td>

                <vs-td :data="identifier.description">{{ identifier.description }}</vs-td>
                <vs-td :data="identifier.documentType.name">{{
                  identifier.documentType.name
                }}</vs-td>
                <vs-td :data="identifier.document">{{
                  getDocument(identifier.document)
                }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      title="Upload Document"
                      icon="UploadCloudIcon"
                      svgClasses="w-5 h-5 stroke-current"
                      @click="
                        uploadIdentifierDocPopUp = true;
                        selectIdentifier = identifier.id;
                      "
                      class="icon_row"
                    />
                    <feather-icon
                      @click="deleteIdentifier(identifier.id)"
                      class="icon_row"
                      title="Delete Identities"
                      icon="XIcon"
                      svgClasses="w-5 h-5 stroke-current"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.additional_info')">
        <div class="tab-text mx-2">
          <vs-table
            :max-items="descriptionItems[0]"
            pagination
            :data="additionalInfoList"
            description
            search
            description-title="Registries"
            description-connector="of"
            description-body="Pages"
          >
            <template slot="header">
              <span class="vx-col order-1">
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="truncate"
                  v-if="!additionalInfoList.length"
                  @click="handleAdditionalInfo"
                  size="small"
                  >{{ $t("customers.label.additional_info") }}</vs-button
                >
              </span>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.nationality") }}</vs-th>
              <vs-th>{{ $t("customers.label.date_of_birth") }}</vs-th>
              <vs-th>{{ $t("customers.label.preferred_language") }}</vs-th>
              <vs-th>{{ $t("customers.label.finance_id") }}</vs-th>
              <vs-th>{{ $t("customers.label.remarks") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(addInfos, index) in data">
                <vs-td :data="addInfos.nationalityId">{{
                  addInfos.nationality || addInfos.nationalityId
                }}</vs-td>
                <vs-td :data="getDate(addInfos.dateOfBirth)">{{
                  getDate(addInfos.dateOfBirth)
                }}</vs-td>
                <vs-td :data="addInfos.preferLanId">{{
                  addInfos.language || addInfos.preferLanId
                }}</vs-td>
                <vs-td :data="addInfos.financeId">{{ addInfos.financeId }}</vs-td>
                <vs-td :data="addInfos.remarks">{{ addInfos.remarks }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.document_uploads')">
        <div class="tab-text mx-2">
          <vs-table :max-items="5" search pagination :data="clientDocuments">
            <template slot="header">
              <span class="vx-col order-1">
                <vs-button
                  color="primary"
                  icon-pack="feather"
                  icon="icon-plus"
                  class="truncate"
                  @click="handleDocumentUploads"
                  size="small"
                  >{{ $t("customers.label.document_uploads") }}</vs-button
                >
              </span>
            </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.name") }}</vs-th>
              <vs-th>{{ $t("customers.label.description") }}</vs-th>
              <vs-th>{{ $t("customers.label.file_name") }}</vs-th>
              <vs-th class="tHeadCenter">{{ $t("customers.label.action") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(document, index) in data">
                <vs-td :data="document.name">{{ document.name }}</vs-td>

                <vs-td :data="document.description">{{ document.description }}</vs-td>
                <vs-td :data="document.fileName">{{ document.fileName }}</vs-td>
                <vs-td class="whitespace-no-wrap">
                  <div class="container_img">
                    <feather-icon
                      icon="EyeIcon"
                      title="View"
                      svgClasses="w-5 h-5 stroke-current cursor text-primary"
                      @click.stop="handleSelected(document.id)"
                      class="icon_row"
                    />
                    <feather-icon
                      title="Download Document"
                      icon="DownloadCloudIcon"
                      svgClasses="w-5 h-5 stroke-current text-cloud"
                      @click="downloadClientDoc(document.id, document.fileName)"
                      class="icon_row"
                    />
                    <feather-icon
                      @click="removeClientDocument(document.id)"
                      class="icon_row"
                      title="Delete"
                      icon="XIcon"
                      svgClasses="w-5 h-5 stroke-current"
                    />
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.payinfo')">
        <div class="tab-text mx-2">
          <vs-table :max-items="5" search pagination :data="paymentInfoData">
            <!-- <template slot="header"> ADD NEW </template> -->
            <template slot="thead">
              <vs-th>{{ $t("customers.label.id") }}</vs-th>
              <vs-th>{{ $t("customers.label.type") }}</vs-th>
              <vs-th>{{ $t("customers.label.card_number") }}</vs-th>
              <vs-th>{{ $t("customers.label.card_type") }}</vs-th>
              <vs-th>{{ $t("customers.label.cardtoken") }}</vs-th>
              <vs-th>{{ $t("customers.label.autopay") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(card, index) in data">
                <vs-td :data="card.name">{{ card.id }}</vs-td>
                <vs-td :data="card.type">{{ card.type }}</vs-td>
                <vs-td :data="card.cardNumber">xxxx xxxx xxx{{ card.cardNumber }}</vs-td>
                <vs-td :data="card.cardType">{{ card.cardType }}</vs-td>

                <vs-td :data="card.clientCardToken">{{
                  formatCardToken(card.clientCardToken)
                }}</vs-td>
                <vs-td :data="card.autoPay">{{ card.autoPay }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab>
      <vs-tab :label="$t('customers.label.billProfile')">
        <ViewBillProfile />
      </vs-tab>
      <!-- <vs-tab :label="$t('customers.label.ach_card')">
        <div class="tab-text mx-2">
          <div class="vx-col md:w-full lg:w-full">
            <ul class="horizontal-sm-btn flex items-center mb-2 float-right">
              <li>
                <div class="my-search-box">
                  <div class="con-input-search vs-table--search">
                    <input
                      type="text"
                      class="input-search vs-table--search-input"
                    />
                    <i
                      class="vs-icon notranslate icon-scale material-icons null"
                      >search</i
                    >
                  </div>
                </div>
              </li>
            </ul>
          </div>
          <vs-table :max-items="5" class="mt-3" pagination :data="achCards">
            <template slot="header"> </template>
            <template slot="thead">
              <vs-th>{{ $t("customers.label.name") }}</vs-th>
              <vs-th>{{ $t("customers.label.ach_card_routing_number") }}</vs-th>
              <vs-th>{{ $t("customers.label.bank_account_number") }}</vs-th>
              <vs-th>{{ $t("customers.label.bank_name") }}</vs-th>
              <vs-th>{{ $t("customers.label.account_type") }}</vs-th>
            </template>
            <template slot-scope="{ data }">
              <vs-tr :key="index" v-for="(achCard, index) in data">
                <vs-td :data="achCard.name">{{ achCard.name }}</vs-td>

                <vs-td :data="achCard.routingNumber">{{
                  achCard.routingNumber
                }}</vs-td>
                <vs-td :data="achCard.bankAccountNumber">{{
                  achCard.bankAccountNumber
                }}</vs-td>

                <vs-td :data="achCard.bankName">{{ achCard.bankName }}</vs-td>
                <vs-td :data="achCard.accountType">{{
                  achCard.accountType
                }}</vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-tab> -->
      <vs-tab :label="parentChildTabLabel">
        <div class="tab-text mx-2">
          <childList :isChild="checkChild" />
        </div>
      </vs-tab>
    </vs-tabs>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.create_client_additional_info')"
        :active.sync="addAdditionalPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer2">
          <form>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.gender")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.gender')"
                    :key="resetKey"
                  >
                    <v-select
                      label="value"
                      v-model="addInfos.gender"
                      :options="infoDataTemplatesadd.genderDatas"
                      :reduce="(gender) => gender.id"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>

              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.id_type")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.id_type')"
                    :key="resetKey"
                  >
                    <v-select
                      label="value"
                      v-model="addInfos.idType"
                      :options="infoDataTemplatesadd.customeridentificationDatas"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(idType) => idType.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.nationality")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.nationality')"
                    :key="resetKey"
                  >
                    <v-select
                      label="mCodeValue"
                      v-model="addInfos.nationality"
                      :options="infoDataTemplatesadd.nationalityDatas"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(obj) => obj.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.id_number')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.id_number')"
                    type="text"
                    class="w-full starlabel font-semibold mb-2"
                    v-model="addInfos.idNumber"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.JobTitle')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.JobTitle')"
                    type="text"
                    class="w-full starlabel font-semibold mb-2"
                    v-model="addInfos.jobTitle"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.age_group")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.age_group')"
                    :key="resetKey"
                  >
                    <v-select
                      label="mCodeValue"
                      v-model="addInfos.ageGroup"
                      :options="infoDataTemplatesadd.ageGroupDatas"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(adjustmentCode) => adjustmentCode.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.date_of_birth")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.date_of_birth')"
                    :key="resetKey"
                  >
                    <datepicker
                      :placeholder="$t('customers.label.SelectDate')"
                      v-model="addInfos.date"
                      class="mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.uts_customer_id')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.uts_customer_id')"
                    type="text"
                    class="w-full starlabel font-semibold mb-5"
                    v-model="addInfos.utsCustomerId"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.preferred_language")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.preferred_language')"
                    :key="resetKey"
                  >
                    <v-select
                      label="mCodeValue"
                      v-model="addInfos.preferredLang"
                      :options="infoDataTemplatesadd.languagesDatas"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(adjustmentCode) => adjustmentCode.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.finance_id')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.finance_id')"
                    type="text"
                    class="w-full starlabel font-semibold mb-2"
                    v-model="addInfos.financeId"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <div class="vx-row">
              <div class="vx-col md:w-1/2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.remarks')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.remarks')"
                    type="text"
                    class="w-full starlabel font-semibold mb-2"
                    v-model="addInfos.remarks"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col md:w-1/2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.preferred_communication")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :name="$t('customers.label.preferred_communication')"
                    :key="resetKey"
                  >
                    <v-select
                      label="mCodeValue"
                      v-model="addInfos.preferredCommunication"
                      :options="infoDataTemplatesadd.cummunitcationDatas"
                      :placeholder="$t('placeholder.label.SelectOne')"
                      :reduce="(adjustmentCode) => adjustmentCode.id"
                      :dir="$vs.rtl ? 'rtl' : 'ltr'"
                      class="min-w-200 w-full mb-2"
                    />
                    <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="center mb-4">
              <!-- <div style="margin-left: 90px">
              <span class="ml-1 mr-1">
                <vs-button
                  class="footerButton-next"
                  @click="addAdditionalPopup = false"
                  style="top: 0px"
                  >{{ $t("customers.label.cancel") }}</vs-button
                >
              </span>
            </div> -->
              <div>
                <span class="ml-1 mr-1">
                  <vs-button
                    @click="addAdditional"
                    class="footerButton-next"
                    style="top: 0px"
                    >{{ $t("customers.label.submit") }}</vs-button
                  >
                </span>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.add_client_identifier')"
        :active.sync="addIdentifierPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer1">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col mb-2 w-full">
                <small class="date-label"
                  >{{ $t("customers.label.document_type")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.document_type')"
                  :key="resetKey"
                >
                  <v-select
                    label="name"
                    :options="idTemplate.allowedDocumentTypes"
                    v-model="identifier.documentTypeId"
                    :reduce="(name) => name.id"
                    :placeholder="$t('customers.label.SelectDocumentType')"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full vs-search-categeory font-semibold"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.unique_identification')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.unique_identification')"
                    class="w-full mb-2 starlabel font-semibold"
                    icon-no-border
                    v-model="identifier.documentKey"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <small class="date-label font-semibold"
                  >{{ $t("customers.label.description")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.description')"
                  :key="resetKey"
                >
                  <vs-textarea
                    v-model="identifier.description"
                    class="font-semibold"
                  ></vs-textarea>
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
            </div>
            <!-- <div class="vx-row" style="margin-left: 30%">
              <span class="ml-4 mr-1">
                <vs-button type="border" @click="resetIdentities">{{
                  $t("customers.label.reset")
                }}</vs-button>
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="addIdentifier">{{
                  $t("customers.label.submit")
                }}</vs-button>
              </span>
            </div> -->
            <div class="center mb-4">
              <div>
                <span class="ml-1 mr-1">
                  <vs-button
                    @click="addIdentifier"
                    class="footerButton-next"
                    style="top: 0px"
                    >{{ $t("customers.label.submit") }}</vs-button
                  >
                </span>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.ViewDocumentUpload')"
        :active.sync="cancelTicketPopup"
        class="popup-close mid-popup"
      >
        <form ref="form">
          <div class="profilePics">
            <img
              v-if="profilePics"
              :src="profilePics"
              id="avatar-pic"
              class="profile-image"
              :style="{ borderColor: categoryColor }"
            />
            <img
              v-else
              src="@/assets/images/avatar/avatar.png"
              id="avatar-pic"
              class="profile-image"
              :style="{ borderColor: categoryColor }"
            />
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.document_uploads')"
        :active.sync="uploadIdentifierDocPopUp"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col mb-2 w-full">
              <vs-input
                :label="$t('customers.label.name')"
                class="w-full font-semibold"
                icon-no-border
                v-model="identifierDocument.name"
              />
            </div>
            <div class="vx-col mb-2 w-full">
              <input
                :label="$t('customers.label.select_file')"
                id="identifierDoc"
                type="file"
                ref="identifierDoc"
                class="w-full font-semibold"
                icon-no-border
                @change="
                  () => (this.identifierDocument.file = this.$refs.identifierDoc.files[0])
                "
              />
            </div>
          </div>
          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="resetForm">{{
                $t("customers.label.clear")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="uploadIdentifierDoc">{{
                $t("customers.label.submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div>
    <div class="centerx">
      <vs-popup
        :title="$t('customers.label.document_uploads')"
        :active.sync="uploadDocumentPopup"
        class="popup-close"
      >
        <ValidationObserver ref="observer3">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col mb-2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.name')"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.name')"
                    class="w-full mb-2 starlabel font-semibold"
                    icon-no-border
                    v-model="clientDocument.name"
                  />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <small class="date-label"
                  >{{ $t("customers.label.description")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  :name="$t('customers.label.description')"
                  :key="resetKey"
                >
                  <vs-textarea class="w-full" v-model="clientDocument.description" />
                  <span class="validate-error" style="color: red">{{ errors[0] }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <pick-file @fileUpdate="onFileChange" />
              </div>
            </div>

            <div class="center mb-4">
              <div>
                <span class="ml-1 mr-1">
                  <vs-button
                    @click="addClientDocument"
                    class="footerButton-next"
                    style="top: 0px"
                    >{{ $t("customers.label.submit") }}</vs-button
                  >
                </span>
              </div>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div>
    <!-- <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.credit_card_details')"
        :active.sync="creditCardDetailsPopUp"
        class="popup-close visible"
      >
        <ValidationObserver ref="observer4">
          <form>
            <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
              <div class="vx-col mb-2 w-full">
                <vs-radio
                  v-model="creditCard.type"
                  vs-value="luis"
                  class="mr-2"
                  >{{ $t("customers.label.CreditCard") }}</vs-radio
                >
                <vs-radio v-model="creditCard.type" vs-value="luis">{{
                  $t("customers.label.Paypal")
                }}</vs-radio>
              </div>
              <div class="vx-col mb-2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="name"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.name')"
                    class="w-full mb-2 starlabel"
                    icon-no-border
                    v-model="creditCard.name"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="card number"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('customers.label.card_number')"
                    class="w-full mb-2 starlabel"
                    icon-no-border
                    v-model="creditCard.cardNumber"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
                <ValidationProvider
                  rules="required"
                  v-if="creditCard.cardNumber"
                  v-slot="{ errors }"
                  name="cvv"
                  :key="resetKey"
                >
                  <vs-input
                    :label="$t('label.cvv')"
                    class="2/2 mb-2 starlabel"
                    icon-no-border
                    v-model="creditCard.cvvNumber"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <small class="date-label"
                  >{{ $t("customers.label.card_type")
                  }}<span class="required"> *</span></small
                >
                <ValidationProvider
                  rules="required"
                  v-slot="{ errors }"
                  name="card type"
                  :key="resetKey"
                >
                  <v-select
                    label="text"
                    :options="cardTypes"
                    v-model="creditCard.cardType"
                    placeholder="Select Card Type"
                    :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    class="min-w-200 w-full"
                  />
                  <span class="validate-error" style="color: red">{{
                    errors[0]
                  }}</span>
                </ValidationProvider>
              </div>
              <div class="vx-col mb-2 w-full">
                <div class="dropdown-with-label">
                  <small class="date-label"
                    >{{ $t("customers.label.expiry_date")
                    }}<span class="required"> *</span></small
                  >
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    name="expiry date"
                    :key="resetKey"
                  >
                    <datepicker
                      placeholder="Select Date"
                      v-model="creditCard.date"
                      class="mb-2 font-semibold"
                    />
                    <span class="validate-error" style="color: red">{{
                      errors[0]
                    }}</span>
                  </ValidationProvider>
                </div>
              </div>
            </div>

            <div class="vx-row">
              <span class="ml-4 mr-1">
                <vs-button type="border" @click="resetForm">{{
                  $t("customers.label.clear")
                }}</vs-button>
              </span>
              <span class="ml-1 mr-2">
                <vs-button @click="addCreditCard('Card')">{{
                  $t("customers.label.submit")
                }}</vs-button>
              </span>
            </div>
          </form>
        </ValidationObserver>
      </vs-popup>
    </div> -->
    <!-- <div class="centerx">
      <vs-popup
        classContent="popup-example"
        :title="$t('customers.label.ach_card')"
        :active.sync="achcardPopUp"
        class="popup-close"
      >
        <form>
          <div class="vx-row md:w-full lg:w-full sm:w-full mb-6">
            <div class="vx-col mb-2 w-full">
              <vs-input
                :label="$t('customers.label.ach_card_routing_number')"
                class="w-full font-semibold"
                icon-no-border
                v-model="achCard.routingNumber"
              />
            </div>
            <div class="vx-col mb-2 w-full">
              <vs-input
                :label="$t('customers.label.bank_account_number')"
                class="w-full font-semibold"
                icon-no-border
                v-model="achCard.bankAccountNumber"
              />
            </div>
            <div class="vx-col mb-2 w-full">
              <vs-input
                :label="$t('customers.label.bank_name')"
                class="w-full"
                icon-no-border
                v-model="achCard.bankName"
              />
            </div>
            <div class="vx-col mb-2 w-full">
              <vs-input
                :label="$t('label.client.achcard.name')"
                class="w-full"
                icon-no-border
                v-model="achCard.name"
              />
            </div>
            <div class="vx-col mb-2 w-full">
              <small>{{ $t("customers.label.account_type") }}</small>
              <div>
                <vs-radio
                  v-model="achCard.accountType"
                  vs-value="luis"
                  class="mr-2"
                  >Checking</vs-radio
                >
                <vs-radio v-model="achCard.accountType" vs-value="luis"
                  >Savings</vs-radio
                >
              </div>
            </div>
          </div>

          <div class="vx-row">
            <span class="ml-4 mr-1">
              <vs-button type="border" @click="resetForm">{{
                $t("customers.label.clear")
              }}</vs-button>
            </span>
            <span class="ml-1 mr-2">
              <vs-button @click="addCreditCard('ACH')">{{
                $t("customers.label.submit")
              }}</vs-button>
            </span>
          </div>
        </form>
      </vs-popup>
    </div> -->
  </div>
</template>
<script>
import Vue from "vue";
import { quillEditor } from "vue-quill-editor";
import moment from "moment";
import _ from "lodash";
import vSelect from "vue-select";
import Datepicker from "vuejs-datepicker";
import { setHeader, removeHeader } from "@/http";
import { createFormData } from "@/plugins";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import childList from "./../childs/Index.vue";
import { mapState } from "vuex";
import { BUCKET_BASE_URL } from "@/http/index";
import PickFile from "@/components/PickFile.vue";
import ViewBillProfile from "./../clientbillprofile/ViewBillProfile.vue";

Object.defineProperty(Vue.prototype, "$_", { value: _ });

// const creditCardObj = {
//   type: "CreditCard",
//   cardType: null,
//   name: null,
//   cvvNumber: null,
//   cardNumber: null,
//   cardExpiryDate: null,
//   date: moment().format("DD MMMM YYYY"),
//   dateFormat: "dd MMMM yyyy",
// };
// const achCardObj = {
//   type: "ACH",
//   routingNumber: null,
//   bankAccountNumber: null,
//   bankName: null,
//   name: null,
//   accountType: "Checking",
// };
const additionalInfoObj = {};

export default {
  props: ["clientId"],
  data() {
    return {
      imagePreview: null,
      imageData: {},
      taxExemption: true,
      descriptionItems: [5, 10, 15],
      serviceOrder: [],
      resetKey: 0,
      addIdentifierPopup: false,
      addAdditionalPopup: false,
      uploadIdentifierDocPopUp: false,
      identifier: {
        documentTypeId: null,
        documentKey: null,
        description: null,
      },
      numbers: Array.from({ length: 100 }, (_, i) => i + 1),
      selectedNumber: 0,
      addInfos: {
        gender: "",
        nationality: "",
        jobTitle: "",
        preferredLang: "",
        remarks: "",
        idType: "",
        idNumber: "",
        ageGroup: "",
        utsCustomerId: "",
        financeId: "",
        preferredCommunication: "",
        dateFormat: "dd MMMM yyyy",
        activationDate: "",
        locale: "en",
        date: moment().format("DD MMMM YYYY"),
      },
      identifierDocument: {
        name: null,
        file: null,
      },
      selectIdentifier: "",
      cancelTicketPopup: false,
      uploadDocumentPopup: false,
      clientDocument: {
        name: null,
        description: null,
        file: null,
      },
      // creditCardDetailsPopUp: false,
      // achcardPopUp: false,
      billProfile: false,
      activeTab: 0,
      additionalInfoList: [],
      // creditCard: creditCardObj,
      cardTypes: ["MASTERCARD", "VISA", "DISCOVERY", "AMERICAN EXPRESS", "OTHERS"],
      // achCard: achCardObj,
      addInfoData: additionalInfoObj,
      id: 0,
    };
  },
  computed: {
    ...mapState({
      formattedDate: (state) => state.settings.selectedDateFormat,
      profilePics: (state) => state.customer.profilePics,
      paymentInfoData: (state) => state.customerMoreInfo.paymentInfoData,
      parentDetails: (state) => state.customerMoreInfo.parentDetails,
    }),
    categoryColor() {
      if (
        this.clientDetail &&
        this.clientDetail.billingInfo &&
        this.clientDetail.billingInfo.type === "Postpaid"
      ) {
        return "#00a031";
      }
      return "#0077a0";
    },
    parentChildTabLabel() {
      return this.parentDetails && this.parentDetails.length > 0
        ? this.$t("customers.label.parent")
        : this.$t("customers.label.childs");
    },
    checkChild() {
      if (this.parentChildTabLabel === "Childs") return true;
      else return false;
    },
    identifiers() {
      return this.$store.getters["customerMoreInfo/GetClientIdentifiers"];
    },
    idTemplate() {
      return this.$store.getters["customerMoreInfo/GetIdentifierTemplate"];
    },
    addtional() {
      return this.$store.getters["customerMoreInfo/AdditionalInfoTemplate"];
    },
    infoDataTemplatesadd() {
      return this.$store.getters["customerMoreInfo/GetAdditionalInfo"];
    },
    clientDocuments() {
      return this.$store.getters["customerMoreInfo/GetClientDocuments"];
    },
    clientDetail() {
      return this.$store.getters["customer/getClientDetailData"];
    },
    clientBillProfile() {
      return this.$store.getters["customerMoreInfo/GetClientBillProfile"];
    },
    // cardDetails() {
    //   return _.filter(
    //     this.$store.getters["customerMoreInfo/GetCreditCardDetails"],
    //     (card) => card.type === "CreditCard" || card.type === "Paypal"
    //   );
    // },
    achCards() {
      return _.filter(this.$store.getters["customerMoreInfo/GetCreditCardDetails"], {
        type: "ACH",
      });
    },
  },
  components: {
    quillEditor,
    "v-select": vSelect,
    Datepicker,
    ValidationProvider,
    ValidationObserver,
    childList,
    PickFile,
    ViewBillProfile,
  },
  watch: {
    activeTab(newValue) {
      if (newValue === 0) {
        this.getIdentifiers();
      } else if (newValue === 1) {
        this.getAdditionals();
      } else if (newValue === 2) {
        this.getDocumentsByClient();
      } else if (newValue === 3) {
        this.getCreditCardDetail();
      }
    },
    addIdentifierPopup(newValue) {
      if (newValue) this.identifierTemplate();
    },
    addAdditionalPopup(newValue) {
      if (newValue) this.additionalInfoTemp();
    },
  },
  methods: {
    getDate(date) {
      if (date) {
        return moment(date).format(this.formattedDate);
      }
    },
    formatCardToken(token) {
      if (token.length <= 4) {
        return token;
      }
      const firstTwo = token.slice(0, 2);
      const lastTwo = token.slice(-2);
      return `${firstTwo}********${lastTwo}`;
    },
    getDocument(document) {
      return _.map(document, "fileName").join(",");
    },
    async identifierTemplate() {
      try {
        await this.$store.dispatch(
          "customerMoreInfo/getIdentifierTemplateAction",
          this.clientId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getDetails() {
      try {
        await this.$store.dispatch(
          "customerMoreInfo/getParentDetailsByChildAction",
          this.$route.params.id
        );
        await this.$store.dispatch(
          "customerMoreInfo/getChildListByParentAction",
          this.$route.params.id
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async additionalInfoTemp() {
      try {
        await this.$store.dispatch(
          "customerMoreInfo/getAdditionalInfoAction",
          this.clientId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getIdentifiers() {
      try {
        await this.$store.dispatch(
          "customerMoreInfo/getClientIdentifiersAction",
          this.clientId
        );

        _.forEach(this.identifiers, async (value) => {
          await this.$store.dispatch(
            "customerMoreInfo/getIdentifierDocumentAction",
            value.id
          );
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getAdditionals() {
      try {
        await this.additionalInfoTemp();
        await this.$store.dispatch(
          "customerMoreInfo/additionalInfoTemplateAction",
          this.clientId
        );
        if (!this.addtional.data.id) return;
        this.additionalInfoList = [this.addtional.data];
        const languageFilter = this.infoDataTemplatesadd.languagesDatas.filter(
          (el) => el.id == this.additionalInfoList[0].preferLanId
        );
        const nationalityFilter = this.infoDataTemplatesadd.nationalityDatas.filter(
          (el) => el.id == this.additionalInfoList[0].nationalityId
        );
        if (languageFilter.length)
          this.additionalInfoList[0].language = languageFilter[0].mCodeValue;
        if (nationalityFilter.length)
          this.additionalInfoList[0].nationality = nationalityFilter[0].mCodeValue;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getDocumentUploadPic(docId) {
      try {
        await this.$store.dispatch("customer/getClientProfilePics", {
          id: this.$route.params.id,
          docId,
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    onFileChange() {
      this.clientDocument.file = this.$refs.clientDocFile.files[0];
    },
    handleAddClientIdentities() {
      this.resetKey++;
      this.addIdentifierPopup = true;
    },
    handleAdditionalInfo() {
      this.resetKey++;
      this.addAdditionalPopup = true;
    },
    handleDocumentUploads() {
      this.resetKey++;
      this.uploadDocumentPopup = true;
    },
    // handleCreditCardDetails() {
    //   this.resetKey++;
    //   this.creditCardDetailsPopUp = true;
    // },

    async addIdentifier() {
      const isValid = await this.$refs.observer1.validate();
      if (!isValid) return;

      try {
        const payload = {
          id: this.clientId,
          data: this.identifier,
        };
        await this.$store.dispatch(
          "customerMoreInfo/addClientIdentifiersAction",
          payload
        );
        this.addIdentifierPopup = false;
        this.getIdentifiers();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Identities Created Successfully!",
          type: "success",
        });
        this.resetForm();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    resetIdentities() {
      (this.identifier.documentTypeId = ""),
        (this.identifier.documentKey = ""),
        (this.identifier.description = "");
    },
    async addAdditional() {
      const isValid = await this.$refs.observer2.validate();
      if (!isValid) return;

      try {
        const payload = {
          id: this.clientId,
          data: this.addInfos,
        };
        await this.$store.dispatch(
          "customerMoreInfo/createAdditionalInfoTemplateAction",
          payload
        );
        this.addAdditionalPopup = false;
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Client's Additional Information Added Successfully!",
          type: "success",
        });
        this.getAdditionals();
        this.resetForm();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async uploadIdentifierDoc() {
      const isValid = await this.$refs.observer3.validate();
      if (!isValid) return;

      try {
        const payload = {
          id: this.selectIdentifier,
          data: createFormData(this.identifierDocument),
        };
        setHeader("Content-Type", "multipart/form-data");
        await this.$store.dispatch(
          "customerMoreInfo/uploadIdentifierDocumentAction",
          payload
        );
        removeHeader("Content-Type");
        this.getIdentifiers();
        this.resetForm();
        this.uploadIdentifierDocPopUp = false;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async deleteIdentifier(id) {
      try {
        const payload = {
          clientId: this.clientId,
          id: id,
        };
        await this.$store.dispatch(
          "customerMoreInfo/deleteClientIdentifiersAction",
          payload
        );
        this.getIdentifiers();
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getDocumentsByClient() {
      try {
        await this.$store.dispatch(
          "customerMoreInfo/getAllClientDocumentsAction",
          this.clientId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async removeClientDocument(id) {
      try {
        const payload = {
          clientId: this.clientId,
          id: id,
        };
        await this.$store.dispatch(
          "customerMoreInfo/deleteClientDocumentAction",
          payload
        );
        this.getDocumentsByClient();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Delete Document Upload Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async addClientDocument() {
      const isValid = await this.$refs.observer3.validate();
      if (!isValid) return;

      try {
        const payload = {
          id: this.clientId,
          data: createFormData(this.clientDocument),
        };
        setHeader("Content-Type", "multipart/form-data");
        await this.$store.dispatch(
          "customerMoreInfo/uploadClientDocumentAction",
          payload
        );
        removeHeader("Content-Type");
        this.uploadDocumentPopup = false;
        this.resetForm();
        this.getDocumentsByClient();
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Document Uploads Created Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async downloadClientDoc(id) {
      const url =
        BUCKET_BASE_URL +
        `/clientticket/${this.clientId}/documents/attachment/${id}?tenantIdentifier=default`;
      window.open(url);
    },
    async handleSelected(docId) {
      await this.$store.dispatch("customer/getClientProfilePics", {
        id: this.$route.params.id,
        docId,
      });
      this.cancelTicketPopup = true;
    },
    async updateTaxExemption() {
      try {
        const payload = {
          id: this.clientId,
          data: {
            taxExemption: this.taxExemption ? this.selectedNumber : 0,
            locale: "en",
          },
        };
        this.$store.dispatch("customerMoreInfo/updateTaxExemptionAction", payload);
        await this.$store.dispatch("customer/setClientDetailData", this.clientId);
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Tax Exemption Updated Successfully!",
          type: "success",
        });
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getBillProfileData() {
      try {
        await this.$store.dispatch(
          "customerMoreInfo/getClientBillProfileAction",
          this.clientId
        );
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getCreditCardDetail() {
      try {
        await this.$store.dispatch("customerMoreInfo/getPaymentsAction", this.clientId);
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    // async addCreditCard(type) {
    //   const isValid = await this.$refs.observer4.validate();
    //   if (!isValid) return;

    //   const data = type === "Card" ? this.creditCard : this.achCard;
    //   try {
    //     const payload = {
    //       id: this.clientId,
    //       data: data,
    //     };
    //     await this.$store.dispatch(
    //       "customerMoreInfo/addClientCardDetailAction",
    //       payload
    //     );
    //     this.getCreditCardDetail();
    //     this.resetForm();
    //     this.creditCardDetailsPopUp = false;
    //     this.achcardPopUp = false;
    //   } catch (error) {
    //     throw Error(
    //       error.message.errors[0].defaultUserMessage ||
    //         `Api failed with status code: ${error.message.httpStatusCode}`
    //     );
    //   }
    // },
    resetForm() {
      if (this.activeTab === 0) {
        this.identifier = {
          documentTypeId: null,
          documentKey: null,
          description: null,
        };
      } else if (this.activeTab === 2) {
        this.clientDocument = {
          name: null,
          description: null,
          file: null,
        };
      } else if (this.uploadIdentifierDocPopUp) {
        this.identifierDocument = {
          name: null,
          file: null,
        };
      }
      // } else if (this.creditCardDetailsPopUp) {
      //   this.creditCard = creditCardObj;
      // } else if (this.achcardPopUp) {
      //   this.achCard = achCardObj;
      // }
    },
    getOrderStatusColor(status) {
      if (status === "Inactive") return "dark";
      if (status === "New") return "warning";
      return "success";
    },
  },
  mounted() {
    this.getDocumentUploadPic();
    this.activeTab = 0;
    this.taxExemption = this.clientDetail.accountInfo.taxExemption === "N" ? false : true;
    this.selectedNumber = this.clientDetail.accountInfo.taxExemption;
    this.getIdentifiers();
    this.getAdditionals();
    this.getDetails();
  },
};
</script>
<style lang="scss">
.small-text-chip {
  background: linear-gradient(
    30deg,
    rgba(var(--vs-primary), 1),
    rgba(var(--vs-primary), 0.5)
  ) !important;
  -webkit-box-shadow: 0 0 8px 0 rgba(var(--vs-primary), 0.4) !important;
  box-shadow: 0 0 8px 0 rgba(var(--vs-primary), 0.4) !important;
  color: #fff;
  border-radius: 5px;
  padding: 3px 5px;
}
.list-item-component {
  -webkit-box-shadow: 0 0 8px 0 rgba(var(--vs-primary), 0.4) !important;
  box-shadow: 0 0 4px 0 rgba(var(--vs-primary), 0.4) !important;
}
.vs-tabs--ul {
  width: 50%;
}
.my-search-box {
  .vs-table--search-input {
    max-width: 150px;
    height: 2.4rem;
    box-shadow: 0 0 4px 0 rgba(var(--vs-primary), 0.4) !important;
  }
  .vs-table--search {
    margin-top: 0;
  }
}
.container-moreinfo {
  position: relative;
  font-size: 0.85rem;
  .my-header {
    position: absolute;

    right: 0;
    z-index: 100;
  }
  .vs-tabs--li button {
    font-size: 0.85rem;
  }
}
.tax {
  width: 66% !important;
}
.profilePics {
  height: 100px;
  width: 100px;
  object-fit: cover;
}
</style>
